import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.requisitos;

class RequisitosService {
  
  // Obtener todos los requisitos
  async getAllRequisitos() {
    try {
      const response = await axios.get(`${API_BASE_URL}/requisitos`);
      return response.data.data || [];
    } catch (error) {
      console.error('Error obteniendo requisitos:', error);
      throw error;
    }
  }

  // Obtener requisito por ID
  async getRequisitoById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/requisitos/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error obteniendo requisito por ID:', error);
      throw error;
    }
  }

  // Crear nuevo requisito
  async createRequisito(requisito) {
    try {
      const response = await axios.post(`${API_BASE_URL}/requisitos`, requisito);
      return response.data.data;
    } catch (error) {
      console.error('Error creando requisito:', error);
      throw error;
    }
  }

  // Actualizar requisito
  async updateRequisito(id, requisito) {
    try {
      const response = await axios.put(`${API_BASE_URL}/requisitos/${id}`, requisito);
      return response.data.data;
    } catch (error) {
      console.error('Error actualizando requisito:', error);
      throw error;
    }
  }

  // Eliminar requisito
  async deleteRequisito(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/requisitos/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error eliminando requisito:', error);
      throw error;
    }
  }

  // Buscar requisitos por criterios
  async searchRequisitos(criterios) {
    try {
      const params = new URLSearchParams();
      if (criterios.id) params.append('id', criterios.id);
      if (criterios.nombre) params.append('nombre', criterios.nombre);
      
      const response = await axios.get(`${API_BASE_URL}/requisitos/search?${params.toString()}`);
      return response.data.data || [];
    } catch (error) {
      console.error('Error buscando requisitos:', error);
      throw error;
    }
  }
}

const requisitosService = new RequisitosService();
export default requisitosService;